import React from 'react'
import BackArrowPrimaryOutlineSVG from "../../../assets/icons/back-arrow-primary-outline.svg"
export const BackArrowPrimaryOutline: React.FC = () => {
  return (
    <img src={BackArrowPrimaryOutlineSVG} alt="" className="w-[22px] h-[23px] cursor-pointer" />
  )
}
